interface CustomIconTrustpilotChannelProps extends React.SVGProps<SVGSVGElement> {}

export function CustomIconTrustpilotChannel({ width, height }: CustomIconTrustpilotChannelProps) {
  return (
    <svg
      fill="none"
      width={width || 48}
      height={height || 48}
      viewBox="0 0 143.7 143.7"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="#00B67A"
        d="M143.7 55.75h-54.9l-16.9-52.2-17 52.2-54.9-.1 44.4 32.3-17 52.2 44.4-32.3 44.4 32.3-16.9-52.2z"
      />
      <path fill="#005128" d="m103.1 99.75-3.8-11.8-27.4 19.9z" />
    </svg>
  );
}
